import dayjs, { Dayjs } from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";

dayjs.extend(customParseFormat);

/** Formato visual unificado en el frontend (no afecta lo enviado al backend). */
export const DATE_DISPLAY_FORMAT = "DD/MM/YYYY";
export const DATE_TIME_DISPLAY_FORMAT = "DD/MM/YYYY HH:mm";

const PARSE_FORMATS = [
  "DD/MM/YYYY",
  "DD/MM/YYYY HH:mm",
  "DD/MM/YYYY HH:mm:ss",
  "YYYY-MM-DD",
  "YYYY-MM-DD HH:mm:ss",
  "YYYY-MM-DDTHH:mm:ss",
  "YYYY-MM-DDTHH:mm:ssZ",
  "YYYY-MM-DDTHH:mm:ss.SSS",
  "YYYY-MM-DDTHH:mm:ss.SSSZ",
];

type DateInput = string | number | Date | Dayjs | null | undefined;

function parseDate(value: DateInput): Dayjs | null {
  if (value == null || value === "") return null;

  if (dayjs.isDayjs(value)) {
    return value.isValid() ? value : null;
  }

  if (value instanceof Date || typeof value === "number") {
    const parsed = dayjs(value);
    return parsed.isValid() ? parsed : null;
  }

  const strict = dayjs(value, PARSE_FORMATS, true);
  if (strict.isValid()) return strict;

  const loose = dayjs(value);
  return loose.isValid() ? loose : null;
}

/** Indica si la fecha es válida y no es un placeholder (ej. año 0001). */
export function isDisplayableDate(value: DateInput): boolean {
  const parsed = parseDate(value);
  return !!parsed && parsed.year() > 1;
}

/** Formatea una fecha para UI como dd/mm/yyyy. */
export function formatDate(value: DateInput): string {
  if (!isDisplayableDate(value)) return "";
  return parseDate(value)!.format(DATE_DISPLAY_FORMAT);
}

/** Formatea fecha y hora para UI como dd/mm/yyyy HH:mm. */
export function formatDateTime(value: DateInput): string {
  if (!isDisplayableDate(value)) return "";
  return parseDate(value)!.format(DATE_TIME_DISPLAY_FORMAT);
}
